"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollLink = void 0;

var react_1 = __importDefault(require("react"));

var Scroll = __importStar(require("react-scroll"));

var identity_1 = require("../../identity");

var utils_1 = require("../../utils");

var ScrollLinkElement = Scroll.Link;

var ScrollLink = function ScrollLink(_a) {
  var elementId = _a.elementId,
      theme = _a.theme,
      _b = _a.stickyHeader,
      stickyHeader = _b === void 0 ? false : _b;
  var style = "w-6 h-12 mb-16 " + (theme ? theme.body.textColor : 'text-gray-100') + " hover:" + (theme ? theme.link.hoverColor : 'text-red-500') + " font-semibold cursor-pointer";
  var wrapper = "flex flex-col items-center w-20 mx-auto bg-transparent text-center";
  var mobile = (0, utils_1.isMobileView)(640);
  var offset = mobile ? -45 : -55;
  return react_1["default"].createElement("div", {
    className: wrapper
  }, react_1["default"].createElement(ScrollLinkElement, {
    className: style,
    to: elementId,
    spy: true,
    smooth: "easeInOutQuint",
    duration: 2500,
    offset: stickyHeader ? offset : 0
  }, react_1["default"].createElement(identity_1.Icon, {
    name: "arrow_down2",
    size: identity_1.IconSize.xs
  })));
};

exports.ScrollLink = ScrollLink;